import { Component, OnInit } from '@angular/core';
import { OnfidoTokenDTO, UuIdDTO, VIDEOSELFING_STATE } from '@app/landing-videoselfing/model/videoselfing-model';
import { VideoSelfingStore } from './services/videoselfing.store';
import { Router } from '@angular/router';
import { LANDING_VIDEOSELFING } from '@app/@core/constants/routes.constants';
import { MatDialog } from '@angular/material/dialog';
import { I18nService } from '@app/i18n';

@Component({
  selector: 'scf-landing-videoselfing',
  templateUrl: './landing-videoselfing.component.html',
  styleUrls: ['./landing-videoselfing.component.scss'],
})
export class LandingVideoselfingComponent implements OnInit {
  public submitted = false;
  public validSms: string;
  public url: string;
  public code: string;
  public onfidoInfo: OnfidoTokenDTO;
  public uuId: UuIdDTO = new UuIdDTO();
  public smsDateInput: string;
  public process: string;
  public stateVideoselfingEnum = VIDEOSELFING_STATE;
  public isError = false;
  public participantsNumber: number;
  public language: string;
  public showFirstStep: boolean = true;

  constructor(
    private videoselfingStore: VideoSelfingStore,
    private router: Router,
    private dialog: MatDialog,
    private i18nService: I18nService
  ) {}

  ngOnInit() {
    //Obtiene el applicantId de la url
    this.url = window.location.href;
    this.process = this.stateVideoselfingEnum.NOTINIT;
    const parts = this.url.split(LANDING_VIDEOSELFING);

    if (parts.length === 2 && parts[1].length > 0) {
      this.code = parts[1];
      this.uuId.uuId = this.code;
    } else {
      console.error('URL no válida');
    }

    //Comprueba si el sms está caducado
    this.videoselfingStore
      .getLanding(this.uuId)
      .then(
        (result) => {
          this.onfidoInfo = result;
          this.smsDateInput = this.onfidoInfo.createdDate;
          this.process = this.onfidoInfo.process;
          this.participantsNumber = this.onfidoInfo.participantsNumber;
          this.isError = false;
          this.language = this.onfidoInfo.language;
          if (this.language == 'CA') {
            this.i18nService.language = 'es-CAT';
          } else {
            this.i18nService.language = 'es-ES';
          }
          //Guarda applicantId en el store
          this.videoselfingStore.setApplicantId(this.onfidoInfo);
        },
        (error) => {
          this.isError = true;
          console.log(error.error.message);
        }
      )
      .catch((error) => console.log(error.error.message))
      .finally(() => this.checkDate(this.smsDateInput));
  }

  //Método para comprobar si hace más de 28 días desde el envío del sms
  checkDate(dateString: string): void {
    const currentDate = new Date();
    const inputDate = new Date(dateString);

    // Calcula la diferencia en milisegundos entre las dos fechas
    const timeDifference = currentDate.getTime() - inputDate.getTime();

    // Calcula el número de días a partir de la diferencia en milisegundos
    const daysDifference = timeDifference / (1000 * 3600 * 24);

    if (daysDifference < 28) {
      this.validSms = 'yes';
    } else {
      this.validSms = 'no';
    }
  }

  isShowFirstStep(event: boolean) {
    this.showFirstStep = event;
  }

  openConsent(): void {
    this.showFirstStep = false;
  }
}
